<template>
    <div class="h-100 d-flex" style="flex-direction: column;">
        <div class="d-flex justify-content-between" style="height: 62px;flex-direction: column;">
            <h4>Статистические показатели потенциальной арендной платы по объектам-аналогам</h4>
            <div class="d-flex justify-content-between align-items-center">
                <span v-if="mean !== null" style="text-align: left;vertical-align: bottom;">Среднее арифметическое значение: {{ get_mean_string(mean) }}</span>
                <!-- <v-select :value="mean_type" :options="mean_types" class="w-50" :searchable="false" :clearable="false"
                    @input="(value) => $emit('set_value', value)"
                /> -->
            </div>
        </div>
        <div :id="id" class="mt-2" style="flex: 1;" v-resize v-on:resize="set_chart" />
    </div>
</template>

<script>
import * as d3 from "d3"
import api from '../../../../../../../api'

export default {
    props: {
        mean_type : String,
		group_id : String,
		query : Object,
		has_oks : Boolean
    },
    
    data()
    {
        return {
            id : "chart_stat",
			data : [],
            mean_types : ['Среднее арифметическое', 'Медианa'],
            mean : null,
        }
    },

    watch :
    {
        mean_type()
        {
            this.set_chart()
		},

		group_id :
		{
			immediate : true,

			handler(group_id)
			{
				this.group_id = group_id
				this.set_chart()
			}
		},

		query :
		{
			immediate : true,

			handler(query)
			{
				this.query = query
				this.set_chart()
			}
		},
    },

    methods :
    {
        set_chart()
        {
			var margin = { top: 32, right: 10, bottom: 32, left: 80 }
            const legend_width = 128

            const base_div = d3.select("#" + this.id)

            if(this.group_id == null || this.query == null || base_div.node() == null)
            {
                return
            }

            const width = base_div.node().getBoundingClientRect().width
            const height = base_div.node().getBoundingClientRect().height

            if (height <= (margin.bottom + margin.top))
            {
                return
            }

			var query = api.deep_clone(this.query)

			query["current_version.group"] = this.group_id
			query["current_version.attrs.bad_profit"] = false

			api.call(this, "cadastral_analogues", "get_many", { query : query },
				response =>
				{
					var data = []

					response.data.forEach(elem => data.push(elem.current_version.attrs))

					this.data = data

					if (this.svg != null)
						this.svg.remove()

					var raw_data = this.data.map(e => { return {...e, season: e.season || "Сезон не указан" } })

					var season_titles = [ "Низкий сезон", "Средний сезон", "Высокий сезон", "Все объекты-аналоги" ]

					if (this.data.find(e => e.season == null)) season_titles = [...season_titles.slice(0,3), "Сезон не указан", season_titles[season_titles.length-1]]
					
					const fx = d3.scaleBand()
						.domain(season_titles)
						.rangeRound([margin.left+40, width - legend_width-40])
						.paddingInner(0.5)
					
					const color = { 
						"Минимальное значение" : { id : "bft-blue-500", value : "var(--bft-blue-500)" },
						"Максимальное значение" : { id : "bft-seagull-500", value : "var(--bft-seagull-500)" },
						"Среднее значение" : { id : "bft-aquamarine-300", value : "var(--bft-aquamarine-300)" },
					}

					const x = d3.scaleBand()
						.domain(Object.keys(color))
						.rangeRound([0, fx.bandwidth()])
						.padding(0.05)

					// Y encodes the height of the bar.
					const y = d3.scaleLinear()
						.domain([0, d3.max(raw_data.filter(e => !e["bad"]), d => d["rent_price"])]).nice()
						.rangeRound([height - margin.bottom - margin.top, margin.top])

					this.svg = base_div.append("svg")
						.attr("width", width)
						.attr("height", height)
						.attr("viewBox", [0, 0, width, height])
						.attr("style", "max-width: 100%; height: auto;")

					// Append the horizontal axis.
					this.svg.append("g")
						.attr("class", "xAxis")
						.attr("transform", `translate(0,${height - margin.bottom - margin.top + 10})`)
						.call(d3.axisBottom(fx).tickSizeOuter(0).tickFormat(
							d =>
								d == "Все объекты-аналоги"
								? d + " (" + raw_data.filter(e => !e["bad"]).length + ")"
								: d + " (" + raw_data.filter(e => e["season"] == d && !e["bad"]).length + ")"
						))
						.call(g => g.selectAll(".domain").remove())
						.selectAll(".tick text")
							.call(this.wrap, fx.bandwidth())

					// Append the vertical axis.
					this.svg.append("g")
						.attr("class", "yAxis")
						.attr("transform", `translate(${margin.left},0)`)
						.call(d3.axisLeft(y).tickSize(-(width-margin.left-legend_width))
							.tickFormat(value => api.number_to_string_with_ranking(value))
						)
						.call(g => g.selectAll(".domain").remove())

					d3.selectAll("g.tick")
						.style("stroke-width", 0.1)
						.style("font-size", 16)
						.style("color", "var(--bft-neutral-400)")
								
					this.svg.append("text")
						.attr("class", "y label")
						.style("font-size", "1rem")
						.style("fill", "var(--bft-neutral-400)")
						.attr("dy", margin.top/2)
						.text(`Потенциальная арендная плата по объектам-аналогам (руб./${ this.has_oks ? "ед. изм." : "кв. м"} в год)`)

					if (this.data.length == 0)
					{
						this.mean = null
						return
					}

					Object.values(color).forEach(value => this.new_gradient(this.svg, value))
					this.svg.append("g")
						.selectAll()
						.data(() => {
							const filtered_data = raw_data.filter(e => !e.bad)
							return [...d3.group(filtered_data, d => d.season), ["Все объекты-аналоги", filtered_data]]
						})
						.join("g")
							.attr("transform", ([season]) => `translate(${fx(season)},0)`)
						.selectAll()
						.data(([, d]) => 
							{
								const mean = this.mean_type == 'Среднее арифметическое' ? d3.mean(d, d => d["rent_price"]) : d3.median(d, d => d["rent_price"])
								this.mean = mean
								return [
									{
										stat : "Минимальное значение",
										value : d3.min(d, e => e["rent_price"])
									},
									{
										stat : "Максимальное значение",
										value : d3.max(d, e => e["rent_price"])
									},
									{
										stat : "Среднее значение",
										value : mean
									}
								]
							}
						)
						.join("rect")
							.attr("x", d => x(d.stat))
							.attr("y", d => y(d.value))
							.attr("width", x.bandwidth())
							.attr("height", d => y(0) - y(d.value))
							.attr("fill", d => `url(#${color[d.stat].id}_${this.id})`)
							.attr("rx", 6)
					
					var legendTable = this.svg.append("g")
						.attr("transform", "translate(" + (width - legend_width + 24) + ", " + (height/2-36) + ")")
						.attr("class", "legendTable");

							var legend = legendTable.selectAll(".legend")
								.data(Object.keys(color))
								.enter().append("g")
								.attr("class", "legend")
								.attr("transform", function(d, i) {
									return "translate(0, " + i * 36 + ")" 
								});
							
							legend.append("rect")
								.attr("width", 8)
								.attr("height", 16)
								.attr("rx", 4)
								.style("fill", d => color[d].value)
							
							legend.append("text")
								.attr("x", 8)
								.attr("dx", 8)
								.attr("y", 8)
								.attr("dy", ".35em")
								.attr("font-size", ".75rem")
								.style("text-anchor", "start")
								.text(d => d)
								.call(this.wrap, legend_width - 30)
				})
        },

        wrap(text, width) {
            text.each(function () {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 1,
                    lineHeight = 1.1, // ems
                    x = text.attr("x"),
                    y = text.attr("y"),
                    dy = 0, //parseFloat(text.attr("dy")),
                    tspan = text.text(null)
                        .append("tspan")
                        .attr("x", x)
                        .attr("y", y)
                        .attr("dy", dy + "em")
                
                while ((word = words.pop())) {
                    line.push(word)
                    tspan.text(line.join(" "))
                    if (tspan.node().getComputedTextLength() > width && line.length > 1) {
						++lineNumber
						line.pop()
						tspan.text(line.join(" "))
						line = [word]
						tspan = text.append("tspan")
							.attr("x", (x * lineNumber))
							.attr("y", y)
							.attr("dy", (lineNumber-1) * lineHeight + dy + "em")
							.text(word)
                    }
                }
            });
        },

        get_mean_string(mean)
        {
            return api.number_to_string_with_ranking(api.round2(mean))
        },

        new_gradient(svg, color)
        {
            const area_gradient_low = svg.append("defs").append("linearGradient")
                .attr("id", color.id + "_" + this.id)
                .attr("x1", "0%")
                .attr("x2", "0%")
                .attr("y1", "0%")
                .attr("y2", "100%")

            area_gradient_low
            .append("stop")
                .attr("offset", "0%")
                .style("stop-color", color.value)
                .style("stop-opacity", 1)
        
            area_gradient_low
                .append("stop")
                    .attr("offset", "100%")
                    .style("stop-color", "#ffffff")
                    .style("stop-opacity", 1)
        },
    }
}
</script>

<style scoped>
* >>> .v-select input
{
    display: none;
}
</style>
